import i18n from "@/i18n"


const PRODUCT_BRAND = "KOMA TOOLS"
const USER_LANG = i18n.global.locale.value//"es"//(navigator.language || navigator.userLanguage).substring(0, 2)

export default {
    PRODUCT_BRAND,
    USER_LANG
};